import { Step } from "@app/core/on-boarding/domain/model/step";

export class StepMapper {
  static deserialize(response: any): Step {
    return {
      order: response.order,
      title: response.title,
      description: response.description,
      image: response.image,
    };
  }
}
